import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
function AnimatedCounter({
  end,
  duration = 2,
  suffix = ''
}: {
  end: number;
  duration?: number;
  suffix?: string;
}) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  useEffect(() => {
    if (isInView) {
      let startTime: number | null = null;
      const animate = (currentTime: number) => {
        if (!startTime) startTime = currentTime;
        const progress = Math.min((currentTime - startTime) / (duration * 1000), 1);
        // Ease out quart
        const easeProgress = 1 - Math.pow(1 - progress, 4);
        setCount(Math.floor(easeProgress * end));
        if (progress < 1) {
          requestAnimationFrame(animate);
        }
      };
      requestAnimationFrame(animate);
    }
  }, [isInView, end, duration]);
  return <span ref={ref} data-id="element-716">
      {count.toLocaleString()}
      {suffix}
    </span>;
}
export function StatsSection() {
  const stats = [{
    value: 15000,
    suffix: '+',
    label: 'Patients Served'
  }, {
    value: 12,
    suffix: '',
    label: 'Years of Excellence'
  }, {
    value: 3,
    suffix: '',
    label: 'Convenient Locations'
  }, {
    value: 98,
    suffix: '%',
    label: 'Patient Satisfaction'
  }];
  return <section className="py-16 bg-brand-dark relative overflow-hidden" data-id="element-717">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-718"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-719">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-720">
          {stats.map((stat, index) => <motion.div key={stat.label} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center" data-id="element-721">
              <div className="text-4xl md:text-5xl font-heading font-bold text-white mb-2" data-id="element-722">
                <AnimatedCounter end={stat.value} suffix={stat.suffix} data-id="element-723" />
              </div>
              <div className="text-brand-gold-light font-medium text-sm md:text-base uppercase tracking-wider" data-id="element-724">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}